module.exports = __webpack_public_path__ + "static/visual-ba5e663ec49b4bb3f995ea93b2191db5.jpg";